angular.module('shared').factory('CreditCardExpirationDatesService', function() {
  return {
    getYears: function() {
      var expirationYearEnd, expirationYearStart;
      expirationYearStart = new Date().getFullYear();
      expirationYearEnd = expirationYearStart + 9;
      return (function() {
        var results = [];
        for (var i = expirationYearStart; expirationYearStart <= expirationYearEnd ? i <= expirationYearEnd : i >= expirationYearEnd; expirationYearStart <= expirationYearEnd ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this);
    },
    getMonths: function() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function(num) {
        if (num < 10) {
          return `0${num}`;
        } else {
          return num.toString();
        }
      });
    }
  };
});
